import { DIALOG_ADD, DIALOG_REDUCE } from '../mutation-types';
interface IDialogState {
    dialogCount: number;
}

const state: IDialogState = {
    dialogCount: 0
};

const mutations = {
    [DIALOG_ADD]( state: IDialogState ): void {

        state.dialogCount = state.dialogCount + 1;

    },
    [DIALOG_REDUCE]( state: IDialogState ): void {

        state.dialogCount = state.dialogCount - 1;

    }
};

const getters = {
    dialogCount: ( state: IDialogState ): number => state.dialogCount
};

export default {
    state,
    mutations,
    getters
};
